import { Component, OnInit, Input } from '@angular/core';
import { Settings, AppSettings } from '../../../app.settings';
import { PageContentService } from 'src/services/pagecontent.service';
import { BroadcastMessageService } from 'src/services/broadcastMessageService';
import { log } from 'util';
@Component({
    selector: 'app-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit {
    @Input() dividers: boolean = true;
    @Input() iconSize: string = 'sm';
    @Input() iconColor: string = '';
    public appliedTheme: any;
    public settings: Settings;
    public siteConfigList: any;
    public multipleLanguage: any[];
    public choosedLang: any;
    public defaultSelectedLanguage: any;
    public valueChanged: boolean = false;
    public name: boolean = true;
    public clicktocall: any;
    constructor(public appSettings: AppSettings, public pageservice: PageContentService, private broadcastMessageService: BroadcastMessageService) {
        this.settings = this.appSettings.settings;
        this.appliedTheme = this.settings.theme;
    }


    ngOnInit() {
        this.siteConfigList = [];
        this.multipleLanguage = [];
        this.getSiteConfig();
        //this.appliedTheme = this.settings.theme;
    }
    getSiteConfig() {
        this.pageservice.getSiteconfig().subscribe(result => {

            if (result != null) {
                this.siteConfigList = result;
                //  this.multipleLanguage = this.siteConfigList.multipleLanguage;
                this.clicktocall = 'tel:' + this.siteConfigList.phoneNumber;

                this.multipleLanguage = this.siteConfigList.multipleLanguage.filter(i => i.isactive == true);
                this.defaultSelectedLanguage = this.multipleLanguage[0].id;
                localStorage.setItem('langId', this.defaultSelectedLanguage);
                //console.log('id',this.defaultSelectedLanguage);
            }
        });
    }
    public changeTheme(theme) {
        debugger;
        this.settings.theme = theme;
    }

    public fontIncreaseTheme(theme) {
        debugger;
        if (this.settings.theme == 'blue') {
            this.settings.theme = theme;
        }
        else if (this.settings.theme == 'red') {
            this.settings.theme = 'purple';
        }
        else if (this.settings.theme == 'green') {
            this.settings.theme = theme;
        }
        else if (this.settings.theme == 'grey') {
            this.settings.theme = 'green';
        }

    }

    public fontDecreaseTheme(theme) {

        if (this.settings.theme == 'blue') {
            this.settings.theme = theme;
        }
        else if (this.settings.theme == 'green') {
            this.settings.theme = 'grey';
        }
        else if (this.settings.theme == 'purple') {
            this.settings.theme = 'red';
        }
        else if (this.settings.theme == 'red') {
            this.settings.theme = 'blue';
        }
    }
    eng(event) {
        debugger;
        if (event == 2) {
            this.broadcastMessageService.sendMessage(event);
            this.name = false
        } else {
            this.broadcastMessageService.sendMessage(event);
            this.name = true
        }


        this.choosedLang = event;
        this.settings.langId = this.choosedLang;
        // console.log('Selected Language :' + this.settings.langId);
        //this.valueChanged = true;
        // this.broadcastMessageService.sendMessage(event);
    }
}
